import httpService from "@src/utility/httpService";
const _httpService = new httpService();
import { config } from '@uhg-abyss/web/tools/config';
import { checkIsInternal } from "./createStorage";
import { commonText } from "@src/constants/common-constants";
    if(checkIsInternal()){
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
    }
    else{
        _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
    }
export const getMetricsData = () => {

    const fetchData = async () => {
        try {
            const response: any = await _httpService.get(
                '/metric-definitions/', 
            );
            return response.Data
            ;
        }
        catch(e) {
           return [];
        }
    };
    return fetchData();
};
export const getProviderMetrics = () => {
    const fetchData = async () => {
        try {
            const providerId = JSON.parse(sessionStorage.getItem('providerInfo') || '{}')?.ProviderSysKey;
            const response: any = await _httpService.get(
                '/provider-metrics-ids/'+providerId
            );
            return response;
            ;
        }
        catch(e) {
           return [];
        }
    };
    return fetchData();
};
export const getProviderMetricsIds = (): Promise<any> => {
  return new Promise(async (resolve, reject) => {
    try {
      const providerId = JSON.parse(sessionStorage.getItem('providerInfo') || '{}')?.ProviderSysKey;
      const response: any = await _httpService.get('/provider-metrics-ids/' + providerId);
      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
};
export const getCurrentUserInfoBykey = (key)  =>{
    const currentUser = getcurrentUser2();
    return currentUser && currentUser[0] ? currentUser[0][key] : '';
  }
export const getHealthCareOrgName = () => {
    return getCurrentUserInfoBykey('HealthCareOrganizationName') ?? "";
  }

  const getcurrentUser2 = () =>{
    try {
      if (sessionStorage.getItem('currentUser')) {
        return JSON.parse(sessionStorage.getItem('currentUser'));
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  }
  export const getcurrentUser = () => {
    if (sessionStorage.getItem('currentUser')) {
      return sessionStorage.getItem('currentUser');
    }
    return null;
  }
  
  export const isMultiTinVal =() =>{
    if (sessionStorage?.getItem('multiTinNavigation')) {
      return true;
    } else {
      return false;
    }
  }
  export const getMultiTins = ()=> {
    if (checkMultiTin()) {
      return sessionStorage.getItem('multiSelectedTins');
    } else {
      return '';
    }
  }
  export function checkMultiTin() {
    return sessionStorage.getItem('multiTinNavigation') &&
      sessionStorage.getItem('multiSelectedTins').split(',').length > 1;
  }
  export const updateGeoSegmentFilters = (state) => {
    if (state && ['REGION', 'STATES'].includes(state.key)) {
      const _value = !Array.isArray(state.value)
        ? { ...state.value, isChipDisable: !!state.value.isChipDisable }
        : state.value.map((value) => ({ ...value, isChipDisable: !!value.isChipDisable }));
      sessionStorage.setItem('GEO_SELECTED_' + state.key, JSON.stringify(_value));
    }
  }
  export function checkHCO() {
    return !sessionStorage.getItem('multiTinNavigation');
  }
  export function getLoggedUser() {
    if (sessionStorage.getItem('loggedUser')) {
      return sessionStorage.getItem('loggedUser');
    }
    return null;
  }

  export const providerKeyData = () => {
    return getCurrentUserInfoBykey('ProviderKey');
  }

  export function matchLobWithFilterLabel(lob) {
    return commonText[lob] || undefined;
  }
  export const checkTin = () => {
    const serializedState = JSON.parse(sessionStorage.getItem('state') || '{}');
    const extendedCorporateTinSelected = serializedState.extendedCorporateTinSelected;
    return extendedCorporateTinSelected && extendedCorporateTinSelected.Tinname !== 'All' && extendedCorporateTinSelected.Tinname !== 'All Selected TINs';
  }
  export const currentState = () => {
    return JSON.parse(sessionStorage.getItem('state') || '{}');
  }

  //KC data
  export const getMetricsDataKc= async (payload:any) =>{
 const url='/metric-definitions/';
    try {
           const responseData: any = await _httpService.get(url, payload);
    
                return responseData;
            } catch {
                return null;
            }
  }
  export const getTopMarketFilterData = async (payload: any) => {
    const url = '/claim-search/topfilter';
    const postData = async () => {
      try {
        const response: any = await _httpService.push(url, payload);
        return response;
      } catch (error) {
        console.error("Error in getTopMarketFilterData:", error);
        return null;
      }
    };
    return postData();
  };